import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UsersListComponent } from './users-list/users-list.component';
import { AddUserComponent } from './add-user/add-user.component';
import { EditUserComponent } from './edit-user/edit-user.component';
import { ViewComponent } from './view/view.component';

const routes: Routes = [
  {
    path: '', component: UsersListComponent,
  },
  {
    path: 'add-user', component: AddUserComponent,
  },
  {
    path: 'edit-user', component: EditUserComponent,
  },
  {
    path:'view', component:ViewComponent
  }
 
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserManagementRoutingModule { }
